// PHASE 1: Where will you use this language most?
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '✈️',
    title: 'pages.onboarding.learningContext.answer1',
    subtitle: 'pages.onboarding.learningContext.answer1Subtitle',
  },
  {
    emoji: '💼',
    title: 'pages.onboarding.learningContext.answer2',
    subtitle: 'pages.onboarding.learningContext.answer2Subtitle',
  },
  {
    emoji: '❤️',
    title: 'pages.onboarding.learningContext.answer3',
    subtitle: 'pages.onboarding.learningContext.answer3Subtitle',
  },
  {
    emoji: '🎓',
    title: 'pages.onboarding.learningContext.answer4',
    subtitle: 'pages.onboarding.learningContext.answer4Subtitle',
  },
  {
    emoji: '🌍',
    title: 'pages.onboarding.learningContext.answer5',
    subtitle: 'pages.onboarding.learningContext.answer5Subtitle',
  },
  {
    emoji: '🏠',
    title: 'pages.onboarding.learningContext.answer6',
    subtitle: 'pages.onboarding.learningContext.answer6Subtitle',
  },
]

export default function LearningContextPage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.learningContext.title"
      subtitle="pages.onboarding.learningContext.subtitle"
    />
  )
}
